import React from "react"

import JoinUsPage from "../../components/JoinUsPage/JoinUsPage";

const JoinUs = () => {
  return <JoinUsPage />
}

export default JoinUs
